export enum DermloopReferralTypeEnum {
  Tele = 'tele',
  Physical = 'physical',
}

export enum ReferralStatus {
  Closed = 'Closed',
  PendingInformation = 'PendingInformation',
  Cancelled = 'Cancelled',
}

export const REFERRAL_STATUS_OPEN_FILTER = 'Open';

/**
 * A referral with no persisted status is open, so `Open` is not a
 * {@link ReferralStatus} value — it is the absence of one. Filtering on the
 * referral lifecycle needs both, hence this widened list.
 */
export const REFERRAL_STATUS_FILTERS = [
  REFERRAL_STATUS_OPEN_FILTER,
  ...Object.values(ReferralStatus),
] as const;
export type ReferralStatusFilter = (typeof REFERRAL_STATUS_FILTERS)[number];

/**
 * Adding `Open` to {@link ReferralStatus} would silently route a persisted
 * `Open` into the "no status" branch of the status filter, so fail the build
 * here instead.
 */
type AssertOpenIsNotAStatus =
  Extract<ReferralStatus, typeof REFERRAL_STATUS_OPEN_FILTER> extends never
    ? true
    : never;
void (true as AssertOpenIsNotAStatus);

/**
 * Which of the two tele-referral workflow shapes produced a referral. `rich` =
 * capture app, where a ConditionTriage consumes the submission against a
 * longitudinal condition; `simple` = desktop e-consult, where the referral
 * itself is the submission consumer and no evaluation step exists. A permanent
 * discriminator, not a migration flag: a referral is rich-or-simple whether or
 * not its form is dynamic.
 */
export enum ReferralWorkflow {
  Rich = 'rich',
  Simple = 'simple',
}
